import React, { useState } from 'react';
import CONST from '../CONST';

const productData = {
    [CONST.PRODUCT_DELUXE]: {
        id: CONST.PRODUCT_DELUXE,
        name: 'Deluxe',
        sku: 170165,
        className: 'deluxe',
        imageName: 'deluxe',
        icidName: 'deluxe',
        purpose: 'Manage your finances',
        platforms: [
            CONST.PLATFORM_WINDOWS,
            CONST.PLATFORM_MAC,
        ],
        features: [
            'Connect banking, credit cards, loans, investments & property',
            'Track monthly bills & see where your money is going',
            'Manage and grow your savings to achieve your financial goals',
            'Create a customized 12-month budget & ensure spending matches your goals',
            'Project different scenarios for loans & investments; use built-in calculators to plan ahead',
            'Create fully customizable views and reports to see your finances your way',
        ],
    },
    [CONST.PRODUCT_SIMPLIFI]: {
        id: CONST.PRODUCT_SIMPLIFI,
        name: 'Simplifi',
        sku: 170313,
        className: 'simplifi',
        imageName: 'simplifi',
        icidName: 'simplifi',
        purpose: 'Manage finances in 5 min/week',
        platforms: [
            CONST.PLATFORM_WEB,
            CONST.PLATFORM_MOBILE,
        ],
        features: [
            'See all your financial accounts in a single dashboard',
            'Automatically downloads & categorizes transactions',
            'Get a personalized budget automatically generated based on income, expenses & savings',
            'Create & track your progress toward short & long-term savings goals',
            'Use powerful timely insights & notifications to reach goals with confidence',
        ]
    },
    [CONST.PRODUCT_PREMIER]: {
        id: CONST.PRODUCT_PREMIER,
        name: 'Premier',
        sku: 170164,
        className: 'premier',
        imageName: 'premier',
        icidName: 'premier',
        purpose: 'Maximize finances & investments',
        platforms: [
            CONST.PLATFORM_WINDOWS,
            CONST.PLATFORM_MAC,
        ],
        features: [
            'Track & grow your investment portfolio with the most robust tools available',
            'Maximize tax benefits & ease prep with built-in tax reports',
            'Manage your spending & savings',
            'Track & pay your bills from Quicken ($119/yr value)',
            'Get priority access to customer support ($49/yr value)',
            'Create fully customizable views & reports to see your finances your way',
        ],
    },
    [CONST.PRODUCT_HOME_AND_BUSINESS]: {
        id: CONST.PRODUCT_HOME_AND_BUSINESS,
        name: 'Home & Business',
        sku: 170166,
        className: 'home-and-business',
        imageName: 'home-and-business',
        icidName: 'hb',
        purpose: 'Manage home, business & rentals',
        platforms: [
            CONST.PLATFORM_WINDOWS,
        ],
        features: [
            'Manage personal & business finances together & separately',
            'Get built-in Schedule C & E tax reports, P&L, cash flow & more',
            'Manage tenants, payments, expenses, lease terms, rates, deposits and more',
            'Store business & rental property documents',
            'Track & grow your investment portfolio with the most robust tools available',
            'Track & pay your bills from Quicken ($119/yr value)',
        ],
    },
}

const runPricingAPI = () => {
    // eslint-disable-next-line
    QuickenGlobal.runQKNPricing(
        {
            priceClasses: 'show',
            suffixClasses: 'show',
            origPriceClasses: 'show',
            origSuffixClasses: 'show',
            percentClasses: 'show'
        },
        'https://www.quicken.com/get_sku_coupon_prices',
    );
};

const imageDir = window.location.host.indexOf('localhost') === 0 ? '/in-product/product-selector/build/images/' : './images/';

const platformData = {
    [CONST.PLATFORM_MAC]: {
        name: 'Mac',
        icon: 'apple',
    },
    [CONST.PLATFORM_WEB]: {
        name: 'Web',
        icon: 'globe',
    },
    [CONST.PLATFORM_WINDOWS]: {
        name: "Windows",
        icon: 'windows',
    },
    [CONST.PLATFORM_MOBILE]: {
        name: 'Mobile',
        icon: 'mobile',
    },
};

const Product = ({ id }) => {
    const [ showMore, setShowMore ] = useState(true);
    const {
        name,
        purpose,
        featureLeadIn,
        features,
        platforms,
        className,
        imageName,
        icidName,
        sku,
    } = productData[id];

    return (
        <div className={ className + ' product' } onLoad={ runPricingAPI }>
            <img className="logo" alt={ name } title={ name } src={ `${imageDir}${imageName}.svg` } />

            <div className="platforms">
                {
                    platforms.map((platform, index) => (
                        <img
                            key={ index }
                            className= { platformData[platform].icon }
                            alt={ platformData[platform].name }
                            title={ platformData[platform].name }
                            src={ `${ imageDir }${ platformData[platform].icon }.svg` }
                        />
                    ))
                }
            </div>

            <p className="purpose">{ purpose }</p>

            <div className="price">
                <span className="percentage" data-qkn-sku={ sku } data-qkn-type="percent"></span>
                <span className="column1">
                    <span className="actual" data-qkn-sku={ sku } data-qkn-type="price"></span>
                    <span className="suffix" data-qkn-sku={ sku } data-qkn-type="suffix"></span>
                </span>
                <span className="column2">
                    <span className="original" data-qkn-sku={ sku } data-qkn-type="originalPrice"></span>
                </span>
            </div>
            <button
                type="button"
                className="buy"
                onClick={
                    () => window.location.href = `/shoppingcart?addproduct=${sku}&icid=20230323|productselector|${icidName}|buynow`
                }
            >Buy Now</button>
            <p className="footnote">
                *Billed annually. Try for 30 days risk-free.
            </p>

            <button
                onClick={ () => setShowMore(!showMore) }
                className={ "less-more " + (showMore ? 'more' : '') }
            >
                SHOW { showMore ? 'LESS' : 'MORE' }
                <img
                    src={ `${imageDir}chevron-up.svg` }
                    alt=""
                    title=""
                />
            </button>
            { showMore && <>
                { featureLeadIn && <p className="lead-in">{ featureLeadIn }</p> }
                <ul>
                    {
                        features.map((feature, index) => (
                            <li key={ index }>{ feature }</li>
                        ))
                    }
                </ul>
            </> }
        </div>
    );
};

export default Product;
